'use strict';

const { h } = require('phy');
const { hydrate } = require('@grpn/hydration');
const { Translate } = require('@grpn/preact-l10n');

const redemptionHandler = require('../../support/redemption-handler');
const { publish } = require('../../support/event-observer');

function RedemptionModalDisruptor(redemptionData) {
  const { merchantName } = redemptionData;

  const enterKeyPressed = ev => {
    const enterKeyCode = 13;

    return ev.code === 'Enter' || ev.keyCode === enterKeyCode;
  };

  const clickSimilarOffersHandler = () =>
    publish('@redemption', {
      ...redemptionData,
      type: 'SIMILAR',
    });
  const keyUpSimilarOffersHandler = ev => {
    if (enterKeyPressed(ev)) {
      clickSimilarOffersHandler();
    }
  };

  const clickRedemptionHandler = () =>
    redemptionHandler({ ...redemptionData, openOutlink: false }).then(data =>
      publish('@redemption', data)
    );

  const keyUpRedemptionHandler = ev => {
    if (enterKeyPressed(ev)) {
      clickRedemptionHandler();
    }
  };

  return h(
    '.redemption-modal-disruptor',
    {
      'data-bhw': 'RedemptionModalDisruptor',
    },
    h('.redemption-modal-content', [
      h(
        Translate,
        { attrs: { class: 'redemption-modal-title' } },
        'js.modules.redemption.DisruptorTitle'
      ),
      h(
        Translate,
        { attrs: { class: 'redemption-modal-subtitle' }, 0: merchantName },
        'js.modules.redemption.DisruptorSubtitleFormat'
      ),
      h('.redemption-modal-action', [
        h(
          Translate,
          {
            tag: 'a',
            attrs: {
              tabindex: 0,
              class: 'btn redemption-modal-button',
              onClick: clickSimilarOffersHandler,
              onKeyUp: keyUpSimilarOffersHandler,
              'data-bhc': 'RedemptionModalDisruptor:show',
            },
          },
          'js.modules.redemption.DisruptorOk'
        ),
        h(
          Translate,
          {
            tag: 'a',
            attrs: {
              tabindex: 0,
              class: 'btn btn-invert redemption-modal-button-invert',
              onClick: clickRedemptionHandler,
              onKeyUp: keyUpRedemptionHandler,
              'data-bhc': 'RedemptionModalDisruptor:cancel',
            },
          },
          'js.modules.redemption.DisruptorCancel'
        ),
      ]),
    ])
  );
}

module.exports = hydrate('RedemptionModalDisruptor', RedemptionModalDisruptor);
